export const PlaidLinkCDNURL = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
